<template>
  <van-popup class="participation" :close-on-click-overlay="false" v-model="show">
    <div class="container">
      <p class="success">
        <svg>
          <use xlink:href="#icon-wancheng" />
        </svg>
      </p>
      <div class="describe">
        <p class="bold inline-block">{{content}}</p>
      </div>
      <p>
        <van-button @click="colseFun">{{$t('300287')}}</van-button>
      </p>
    </div>
    <div class="close">
      <svg @click="colseFun">
        <use xlink:href="#icon-guanbi2" />
      </svg>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Button } from 'vant'
export default {
  components: {
    VanPopup: Popup,
    VanButton: Button
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    colseFun: {
      type: Function,
      default: () => { }
    },
    content:{
        type:String,
        default:''
    }
  },
  data() {
    return {

    }
  },
  created(){
    console.log(this.content)
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/variableName";
@import "../../../style/mixin";
.participation {
  background: transparent;
  .container {
    .success {
      text-align: center;
      svg {
        width: torem(48);
        height: torem(48);
      }
    }
    .describe {
      //   height: torem(24);
      // box-sizing: border-box;
    //   width: 100%;
      margin: torem(16) 0;
      text-align: center;
      .bold {
        line-height: torem(24);
        font-size: torem(16);
        text-align: center;
      }
    }
    width: torem(312);
    height: torem(196);
    border-radius: torem(8);
    padding: torem(24);
    background: #ffffff;
    .van-button {
      width: torem(264);
      height: torem(44);
      background: #ffc72b;
      border: none;
      border-radius: torem(4);
      font-size: torem(16);
    }
  }
  .close {
    margin-top: torem(28);
    text-align: center;
    svg {
      width: torem(28);
      height: torem(28);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/purchase/compontents/tipsModel.vue